import { forwardRef, memo, useState } from 'react'

const TrucoInfoMessage = forwardRef((props, ref) => {
    
    return (
        <div className='truco-info-message-container'>
            <div className='truco-info-message-box'>
                <div className='truco-info-message'>{props.playerMessage}</div>
            </div>
        </div>
    )
})

export default memo(TrucoInfoMessage)